var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSahl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 26 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95058 23.5509C9.95058 23.5509 5.97712 23.5509 2.37336 23.5509C1.41365 23.5509 0.548397 22.9712 0.18093 22.0821C-0.186536 21.193 0.0161217 20.1694 0.694434 19.4886C6.29351 13.8683 16.1471 3.97755 19.9928 0.117297C20.1297 -0.020058 20.3451 -0.0390334 20.5037 0.0722959C20.6623 0.183625 20.7183 0.393107 20.6365 0.569077C17.8518 6.55807 9.95057 23.5509 9.95057 23.5509L9.95058 23.5509Z",
    fill: "#4055FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4738 16.4491C15.4738 16.4491 19.4473 16.4491 23.051 16.4491C24.0107 16.4491 24.876 17.0288 25.2435 17.9179C25.6109 18.807 25.4083 19.8306 24.73 20.5114C19.1309 26.1317 9.27727 36.0224 5.43157 39.8827C5.29474 40.0201 5.07931 40.039 4.92069 39.9277C4.76207 39.8164 4.70608 39.6069 4.7879 39.4309C7.57262 33.4419 15.4738 16.4491 15.4738 16.4491H15.4738Z",
    fill: "#4055FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSahl);
export default __webpack_public_path__ + "static/media/sahl.4c649685694a0b6993abe9e53f645384.svg";
export { ForwardRef as ReactComponent };